<template>
  <div class="block-datos-resumen cl">
    <div>
      <dl class="contenido">
        <dt>Marca:</dt>
        <dd>{{ resumen.marca }}</dd>
        <dt>Modelo:</dt>
        <dd>{{ resumen.modelo }}</dd>
        <dt>Version:</dt>
        <dd>{{ resumen.version }}</dd>
        <dt>Combustible:</dt>
        <dd>{{ resumen.combustible }}</dd>
        <dt>Año fabricación:</dt>
        <dd>{{ resumen.anhoFabricacion }}</dd>
        <dt>Adquisición:</dt>
        <dd>{{ resumen.adquisicion }}</dd>
        <dt>Año primera matriculación:</dt>
        <dd>{{ resumen.anhoPrimeraMat }}</dd>
        <dt>Lugar aparcamiento:</dt>
        <dd>{{ resumen.aparcamiento }}</dd>
        <dt>Elementos de seguridad:</dt>
        <dd>{{ resumen.seguridad }}</dd>
        <dt>Kilómetros anuales:</dt>
        <dd>{{ resumen.kmAnuales }}</dd>
        <dt>Uso:</dt>
        <dd>{{ resumen.uso }}</dd>
        <dt>Frecuencia de uso:</dt>
        <dd>{{ resumen.frecUso }}</dd>
        <dt>Remolque:</dt>
        <dd>{{ resumen.remolque }}</dd>
        <span>
          <dt>Importe accesorios:</dt>
          <dd v-if="resumen.importeAccesorios != null">
            {{ resumen.importeAccesorios | currencyEUR }}
          </dd>
          <dd v-else>Sin accesorios</dd>
        </span>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  store: ["step"],
  props: {
    resumen: {
      type: Object
    }
  }
};
</script>

<style></style>
